import React from 'react';
import { getConfig, Config } from './config'
import './index.css'
const serverDefinitionPart = '/services/authentication/getServerDefinition'

interface State {
  config: Config;
  statusCode: number;
  error: string;
}
interface Props {
}
export default class CheckStatus extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { config: null, statusCode: 0, error: null }
  }

  componentDidMount(): void {
    getConfig().then(async (c) => {
      await this.getServerStatus(c.serverUrl);
      this.setState({ config: c });

    })
  }

  componentDidUpdate(): void {
    const { statusCode: code } = this.state;
    (code === 200) ? this.drawOk() : this.drawFailed(code);
  }
  private drawOk() {
    const elem = document.getElementById("status");
    elem.innerHTML = "<div class='serverOk'>OK</div><!--__STATUS__OK__-->";
  }
  private drawFailed(code: number) {
    const elem = document.getElementById("status");
    elem.innerHTML = "<div class='serverFailed'>FAIL - StatusCode:" + code + "</div><!--__STATUS__FAILED__-->";
  }
  private async getServerStatus(serverUrl: string) {
    window.fetch(serverUrl + serverDefinitionPart, { method: 'POST' }).then((b) => {
      this.setState({ statusCode: b.status });
    }).catch((e) => {
      this.setState({ statusCode: 500 });
    })
  }

  public render(): JSX.Element {
    const buildStatus = {
      minWidth: 200
    }
    const { config: _c, error: _e } = this.state;
    if (!_c) {
      return null;
    }
    return (

      <div className="container body-content">

        <h2>Metadata CheckStatus</h2>
        <table>
          <tr>
            <td style={buildStatus as any}>Build Number</td>
            <td>{_c.buildNo}</td>
          </tr>
          <tr>
            <td>Clarizen API server URL</td>
            <td>{_c.serverUrl}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td><div id="status" /></td>
            <td>{_e}</td>
          </tr>
        </table>
        <hr />
        <footer>
          <p>&copy;  - Metadata Explorer</p>
        </footer>
      </div>
    );
  }
}
